'use strict';

function menuAnimation() {
	$('.openmenu').on('click', function (e) {
		e.preventDefault();
		var mainHeader = $('body');
		var mainNavigation = $('#main-navigation');
		if (mainHeader.hasClass('is-open-menu')) {
			//$(this).find('.openmenu-icon').removeClass('open');
			mainNavigation.slideUp();
			mainHeader.removeClass('is-open-menu');
		} else {
			//$(this).find('.openmenu-icon').addClass('open');
			mainHeader.addClass('is-open-menu');
			mainNavigation.slideDown();
		}
	});
}